/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/auth/authService'

import firebase from 'firebase/app'
import 'firebase/auth'
import ls from "@/common/localStorage"
import con from "@/firebase/firebaseInit.ts";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },    
    routes: [

        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '',
            component: () =>
                import (/* webpackPrefetch: true */ /* webpackChunkName: "main" */ './layouts/main/Main.vue'),
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    path: '/',
                    //redirect: '/event/analytics'
                    redirect: '/pages/login'
                },
                {
                    path: '/dashboard/analytics',
                    name: 'dashboard-analytics',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "dashboard" */'./views/DashboardAnalytics.vue'),
                    meta: {
                        rule: 'editor'
                    }
                    //beforeEnter() {location.href = 'https://onair2cms.e2m.live/dashboard/analytics'}
                },
                {
                    path: '/dashboard/ecommerce',
                    name: 'dashboard-ecommerce',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "dashboard" */'./views/DashboardECommerce.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/client/list',
                    name: 'client-list',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "client" */'./views/client/ClientList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/client/edit',
                    name: 'client-edit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "client" */'./views/client/ClientEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/client/add',
                    name: 'client-add',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "client" */'./views/client/ClientAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/client/PlayerLog',
                    name: 'player-log',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "client" */'./views/client/PlayerLog.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                /*{
                    path: '/user/list',
                    name: 'user-list',
                    component: () =>
                        import ('./views/user/UserList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/user/edit',
                    name: 'user-edit',
                    component: () =>
                        import ('./views/user/UserEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/bulkupload',
                    name: 'bulkupload',
                    component: () =>
                        import ('./views/bulkupload/BulkUpload.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },*/

                /////////////////////////////////////////////////////////////////////////////////////////////      
                /////////////////////////////////////////////////////////////////////////////////////////////

                {
                    path: '/event/dashboard',
                    name: 'event-dashboard',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "dashboard" */'./views/dashboard/DashboardListing.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/expo-dashboard',
                    name: 'exhibitor-dashboard',
                    component: () =>
                        import ('./views/dashboard/ExpoDashboardListing.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/reg-dashboard',
                    name: 'registration-dashboard',
                    component: () =>
                        import ('./views/dashboard/RegDashboardListing.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/realtimedashboard',
                    name: 'realtimedashboard',
                    component: () =>
                        import ('./views/dashboard/RealtimeDashboard.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/virtuallobby',
                    name: 'Virtual-lobby',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "lobby" */'./views/virtuallobby/VirtuallobbyAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/list',
                    name: 'event-list',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "event" */'./views/event/EventList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/listv2',
                    name: 'event-list-v2',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "event" */'./views/event/EventListv2.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/add',
                    name: 'event-add',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "event" */'./views/event/EventAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/addv2',
                    name: 'event-addv2',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "event" */ './views/event/EventAddV2.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/custombranding',
                    name: 'custom-branding',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "event" */'./views/event/CustomBranding.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/edit',
                    name: 'event-edit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "event" */'./views/event/EventEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/manage-menu',
                    name: 'manage-menu',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "event" */'./views/event/manage-menu.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/mailtpl/list',
                    name: 'mailtpl-list',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "mail" */'./views/mailtpl/MailtplList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/menu/list',
                    name: 'menu-list',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "mail" */'./views/menu/MenuListing.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/menu/add',
                    name: 'menu-add',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "mail" */'./views/menu/MenuAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/tagscategpryins',
                    name: 'tagscategpryinstance',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "tags" */'./views/TagsCategpryInstance.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/mailtpl/add',
                    name: 'mailtpl-add',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "mail" */'./views/mailtpl/MailtplAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/mailtpl/edit/:DocName/:CollectionName',
                    name: 'mailtpl-edit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "mail" */'./views/mailtpl/MailtplEditNew.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },           

                {
                    path: '/event/attendees',
                    name: 'attendees',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "attendee" */'@/views/attendee/AttendeeList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/paidregistrants',
                    name: 'PaidRegistrants',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "attendee" */'@/views/attendee/AttendeeListReg.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/registrationform',
                    name: 'RegistrationForm',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "attendee" */'@/views/attendee/AttendeeRegAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/editregform',
                    name: 'regform-edit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "attendee" */'@/views/attendee/AttendeeRegEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/registrationforms',
                    name: 'RegistrationForms',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "attendee" */'@/views/attendee/RegistrationForms.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/checkoutforms',
                    name: 'CheckoutForms',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "form" */'@/views/checkoutform/FormList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/addcheckoutform',
                    name: 'add-checkoutform',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "form" */'@/views/checkoutform/FormAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/editcheckoutform/:FormId',
                    name: 'edit-checkoutform',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "form" */'@/views/checkoutform/FormAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/leaderboard',
                    name: 'LeaderBoard',
                    component: () =>
                        import ('@/views/leaderboard/List.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/gamification',
                    name: 'Gamification',
                    component: () =>
                        import ('@/views/leaderboard/Gamification.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/chat',
                    name: 'Chat',
                    component: () =>
                        import ('@/views/chat/Chat.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/chatgroups',
                    name: 'Chatgroups',
                    component: () =>
                        import ('@/views/chatgroup/List.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/editchatgroup',
                    name: 'chatgroup-edit',
                    component: () =>
                        import ('@/views/chatgroup/Edit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/addchatgroup',
                    name: 'chatgroup-add',
                    component: () =>
                        import ('@/views/chatgroup/Add.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/tickets',
                    name: 'Tickets',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "tickets" */'@/views/ticket/TicketList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/editticket',
                    name: 'ticket-edit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "tickets" */'@/views/ticket/TicketEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/addticket',
                    name: 'ticket-add',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "tickets" */'@/views/ticket/TicketAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/notification',
                    name: 'notification',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "notification" */'@/views/notification/NotificationList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/notification/edit/',
                    name: 'notificationedit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "notification" */'@/views/notification/NotificationEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/attendee/edit',
                    name: 'attendee-edit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "attendee" */'@/views/attendee/AttendeeEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/attendee/add',
                    name: 'attendee-add',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "attendee" */'@/views/attendee/AttendeeAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/attendee/all',
                    name: 'attendee-all',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "attendee" */'@/views/attendee/AttendeeAll.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/custompages',
                    name: 'custompages',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "custom" */'@/views/custompages/PageList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/custompages/add',
                    name: 'custompages-add',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "custom" */'@/views/custompages/PageAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/custompages/edit',
                    name: 'custompages-edit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "custom" */'@/views/custompages/PageEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/sessions',
                    name: 'sessions',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "sessions" */'@/views/session/SessionList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/session/add',
                    name: 'session-add',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "sessions" */'@/views/session/SessionAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/session/edit/:sessionId',
                    name: 'session-edit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "sessions" */'@/views/session/SessionEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/session/viewDetails',
                    name: 'session-view-details',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "sessions" */'@/views/session/SessionViewDetails.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '#', active: true },
                            { title: 'Sessions Listing', url: '/event/sessions', active: true },
                            { title: 'Session Details', url: '/event/session/viewDetails', active: true },
                        ],
                        pageTitle: 'Session Details',
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/speakers',
                    name: 'speakers',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "speakers" */'@/views/speaker/SpeakerList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/speaker/add',
                    name: 'speaker-add',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "speakers" */'@/views/speaker/SpeakerAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/speaker/edit',
                    name: 'speaker-edit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "speakers" */'@/views/speaker/SpeakerEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/qnalist',
                    name: 'qnalist',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "qna" */'@/views/qna/QnAList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/qnalistp',
                    name: 'qnalistp',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "qna" */'@/views/qna/QnAListP.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/sessionmapping',
                    name: 'sessionmapping',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "session" */'@/views/agenda/SessionMapping.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/usermapping',
                    name: 'usermapping',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "agenda" */'@/views/agenda/UserMapping.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/groupmapping',
                    name: 'groupmapping',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "agenda" */'@/views/agenda/GroupMapping.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/groups',
                    name: 'groups',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "agenda" */'@/views/agenda/GroupList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/group/edit',
                    name: 'group-edit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "agenda" */'@/views/agenda/GroupEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/photowalls',
                    name: 'photowalls',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "photowall" */'@/views/photowall/PhotowallList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/photowall/add',
                    name: 'photowall-add',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "photowall" */'@/views/photowall/PhotowallAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/photowall/resize',
                    name: 'photowall-resize',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "photowall" */'@/views/photowall/PhotowallResize.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/photowall/component',
                    name: 'photowall-component',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "photowall" */'@/views/photowall/PhotowallResizeComponent.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/sponsors',
                    name: 'sponsors',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "sponsor" */'@/views/sponsor/SponsorList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                // {
                //     path: '/TagsCategoryInstancePriority',
                //     name: 'tagscategoryinstancepriority',
                //     component: () =>
                //         import ('@/views/TagsCategoryInstancePriority.vue'),
                //     meta: {
                //         rule: 'admin'
                //     }
                // },
                {
                    path: '/event/sponsor/add',
                    name: 'sponsor-add',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "sponsor" */'@/views/sponsor/SponsorAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/sponsor/edit',
                    name: 'sponsor-edit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "sponsor" */'@/views/sponsor/SponsorEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/speaker/list',
                    name: 'speaker-list',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "speaker" */'@/views/speaker/SpeakerList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/speaker/edit/:speakerId',
                    name: 'speaker-edit-id',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "speaker" */'@/views/speaker/SpeakerEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },                             
                {
                    path: '/event/analytics',
                    name: 'analytics',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "analytic" */'@/views/event/Analytics.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/exhibitors',
                    name: 'exhibitor',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "exhibitors" */'@/views/exhibitors/ExhibitorList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/exhibitorshallsetup',
                    name: 'exhibitors-hall-setup',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "exhibitors" */'@/views/exhibitors/ExhibitorHallSetup.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/exhibitor/add',
                    name: 'exhibitor-add',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "exhibitors" */'@/views/exhibitors/ExhibitorAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/exhibitor/edit/',
                    name: 'exhibitor-edit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "exhibitors" */'@/views/exhibitors/ExhibitorEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/report/businessCard',
                    name: 'report-businessCard',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "report" */'@/views/exhibitors/ExhibitorBusinessCardDetailsList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/roundtables',
                    name: 'roundtables',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "roundtable" */'@/views/roundtable/RoundtableList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/roundtable/add',
                    name: 'roundtable-add',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "roundtable" */'@/views/roundtable/RoundtableAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/roundtable/seating',
                    name: 'roundtable-seating',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "roundtable" */'@/views/roundtable/RoundtableSeating.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/roundtable/edit',
                    name: 'roundtable-edit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "roundtable" */'@/views/roundtable/RoundtableEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/roundtable/viewDetails',
                    name: 'roundtable-view-details',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "roundtable" */'@/views/roundtable/RoundtableViewDetails.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '#', active: true },
                            { title: 'RoundTable Listing', url: '/event/roundtables', active: true },
                            { title: 'Participants Details', url: '/event/roundtable/viewDetails', active: true },
                        ],
                        pageTitle: 'Participants Details',
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/meetings',
                    name: 'meetings',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "meeting" */'@/views/meeting/MeetingList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/TagsCategoryInstanceEdit',
                    name: 'instancetagsedit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "tags" */'@/views/TagsCategoryInstanceEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/agenda/timeline',
                    name: 'timeline',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "agenda" */'@/views/agenda/TimeLine.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/overview/overview',
                    name: 'overview2',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "overview" */'@/views/overview/Overview.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/overview/:tour?',
                    name: 'overview',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "overview" */'@/views/overview/Overview2.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/plugins',
                    name: 'manage-plugins',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "plugins" */'./views/event/ManagePlugins.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/virtuallobby/virtuallobbyhotspot',
                    name: 'virtuallobbyhotspot',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "lobby" */'@/views/virtuallobby/VirtuallobbyImageHotspot.vue'),

                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/resources',
                    name: 'resource',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "resource" */'@/views/resources/ResourceList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/checkin',
                    name: 'checkinteam',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "resource" */'@/views/checkinteam/TeamList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/checkintype',
                    name: 'checkintype',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "resource" */'@/views/checkinteam/TypeList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                /*{
                    path: '/TagsCategoryInstanceAdd',
                    name: 'instancetagsadd',
                    component: () =>
                        import ('@/views/TagsCategoryInstanceAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },*/
                // {
                //     path: '/event/report-downloads',
                //     name: 'event-report-downloads',
                //     component: () =>
                //         import ('@/views/ExcelExport.vue'),
                //     meta: {
                //         rule: 'admin'
                //     }
                // },
                {
                    path: '/analytics/page-view',
                    name: 'analytics-page-view',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "analytic" */'@/views/analytics/PageView.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/analytics/page-view-user',
                    name: 'analytics-page-view-user',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "analytic" */'@/views/analytics/PageViewUser.vue'),
                    //meta: {
                    //    rule: 'admin'
                    //},
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/analytics/page-view', active: false },
                            { title: 'Page Engagement', url: '/analytics/page-view', active: true },
                            { title: 'Users', active: true }
                        ],
                        pageTitle: 'Page Engagement',
                        rule: 'editor'
                    }
                },
                {
                    path: '/analytics/page-view-user-details',
                    name: 'analytics-page-view-user-details',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "analytic" */'@/views/analytics/PageViewUserDetails.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/analytics/page-view', active: false },
                            { title: 'Page Engagement', url: '/analytics/page-view', active: true },
                            //{ title: 'Page View', url: '/analytics/page-view-user', active: true },
                            { title: 'User Actions', active: true }
                        ],
                        pageTitle: 'Page Engagement',
                        rule: 'editor'
                    }
                },
                {
                    path: '/analytics/user-journey',
                    name: 'analytics-user-journey',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "analytic" */'@/views/analytics/UserJourney.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/analytics/user-journey-details',
                    name: 'analytics-user-journey-details',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "analytic" */'@/views/analytics/UserJourneyDetails.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/analytics/user-journey', active: false },
                            { title: 'User Journey', url: '/analytics/user-journey', active: true },
                            { title: 'Journey Details', active: true }
                        ],
                        pageTitle: 'User Journey',
                        rule: 'editor'
                    }
                },
                {
                    path: '/analytics/user-login',
                    name: 'analytics-user-login',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "analytic" */'@/views/analytics/UserLogin.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/analytics/live-visitor',
                    name: 'analytics-live-visitor',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "analytic" */'@/views/analytics/LiveVisitor.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/form/list',
                    name: 'form-list',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "form" */'@/views/form-builder/List.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/form/add',
                    name: 'form-add',
                    // meta: { layout: "default" },
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "form" */"@/views/form-builder/Add.vue"),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/form/add1',
                    name: 'form-add1',
                    // meta: { layout: "default" },
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "form" */"@/views/form-builder/Add1.vue"),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/form/edit/:id',
                    name: 'form-edit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "form" */'@/views/form-builder/Edit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },  
                {
                    path: '/event/floormaps',
                    name: 'floormaps',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "form" */'@/views/floormap/FloorMapList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                }, 
                {
                    path: '/event/floormap/add',
                    name: 'floormap-add',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "form" */'@/views/floormap/FloorMapAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                }, 
                {
                    path: '/event/floormap/edit/:id',
                    name: 'floormap-edit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "form" */'@/views/floormap/FloorMapEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                }, 
                {
                    path: '/event/boothmaps/:mid',
                    name: 'boothmaps',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "form" */'@/views/floormap/BoothMapList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },  
                {
                    path: '/event/rootmaps/:mid',
                    name: 'rootmaps',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "form" */'@/views/floormap/RootMapList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },   
                {
                    path: '/event/venue/add',
                    name: 'venue-add',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "venue" */'@/views/venue/VenueAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },       
                {
                    path: '/event/venue/edit/:id',
                    name: 'venue-edit',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "venue" */'@/views/venue/VenueEdit.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },    
                {
                    path: '/event/venues',
                    name: 'venuelist',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "venue" */'@/views/venue/VenueList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/checkin/location',
                    name: 'checkinlocation',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "venue" */'@/views/checkin/location/LocationList.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/checkin/settings',
                    name: 'checkinsettings',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "venue" */'@/views/checkin/location/CheckinSettings.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                {
                    path: '/event/checkin/reports',
                    name: 'checkinreports',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "venue" */'@/views/checkin/reports/CheckinReports.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },

                {
                    path: '/event/checkin-dashboard',
                    name: 'Checkin-dashboard',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "venue" */'@/views/checkin/location/GeoLocationDashboard.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },
                
                 
				 
                // =============================================================================
                // COMPONENT ROUTES
                // =============================================================================
                {
                    path: '/event/notification/add',
                    name: 'notification-add',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "notification" */'@/views/notification/NotificationAdd.vue'),
                    meta: {
                        rule: 'admin'
                    }
                },               
                
            ]
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () =>
                import (/* webpackPrefetch: true */ /* webpackChunkName: "full-page" */ '@/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '/event/session/video/:SessionId/:TypeId',
                    name: 'session-video',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "session" */'@/views/session/SessionVideo.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },                
                {
                    path: '/pages/login',
                    //name: 'page-login',
                    name: con.Environment == 'HTX' ? 'HTX Mobile Safety App' : 'e2m.live Event Management System - Web & Apps',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "login" */'@/views/pages/login/Login.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/forgot-password',
                    name: 'page-forgot-password',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "login" */'@/views/pages/ForgotPassword.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/reset-password',
                    name: 'page-reset-password',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "login" */'@/views/pages/ResetPassword.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "error" */'@/views/pages/Error404.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
                {
                    path: '/pages/error-500',
                    name: 'page-error-500',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "eror" */'@/views/pages/Error500.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },                
                {
                    path: '/pages/maintenance',
                    name: 'page-maintenance',
                    component: () =>
                        import (/* webpackPrefetch: true */ /* webpackChunkName: "error" */'@/views/pages/Maintenance.vue'),
                    meta: {
                        rule: 'editor'
                    }
                },
               

            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ]
})

router.afterEach((to, from) => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = 'none'
    }
    Vue.nextTick(() => {
        if(ls.getSessionValueByKey("Session_Event_FullName"))
            document.title = `${to.name.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') } - ${ls.getSessionValueByKey("Name")} - ${ls.getSessionValueByKey("Session_Event_FullName")}(${ls.getSessionValueByKey("ClientName")})` || "E2M Onair CMS";
        else
            document.title = to.name.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') || "E2M Onair CMS";
    });
    router.checkLoginTime()

})

router.beforeEach((to, from, next) => {
    firebase.auth().onAuthStateChanged(() => {

        // get firebase current user
        const firebaseCurrentUser = firebase.auth().currentUser

        // if (
        //     to.path === "/pages/login" ||
        //     to.path === "/pages/forgot-password" ||
        //     to.path === "/pages/error-404" ||
        //     to.path === "/pages/error-500" ||
        //     to.path === "/pages/register" ||
        //     to.path === "/callback" ||
        //     to.path === "/pages/comingsoon" ||
        //     (auth.isAuthenticated() || firebaseCurrentUser)
        // ) {
        //     return next();
        // }

        // If auth required, check login. If login fails redirect to login page
        if (to.meta.authRequired) {
            if (!(auth.isAuthenticated() || firebaseCurrentUser)) {
                router.push({ path: '/pages/login', query: { to: to.path } })
            }
        }


        if (ls.checkLogin()) {
            //router.push({ path: '/event/list', query: { to: to.path } })
        } else {

            if (
                to.path === "/pages/login" || 
                to.path === "/pages/forgot-password" ||
                to.path === "/pages/error-404" ||
                to.path === "/pages/error-500" ||
                to.path === "/pages/register" ||
                to.path === "/callback" ||
                to.path === "/pages/comingsoon"
            ) {
                //return next();
            } else {
                //alert("You are not Logged In!")
                router.push({ path: '/pages/login', query: { to: to.path } })
            }


        }
        if (ls.getSessionValueByKey("Role") == 4) {
            if (
                to.path === "/event/dashboard" ||
                to.path === "/event/list" ||
                to.path.includes("/analytics") || to.path === "/pages/login"
            ) {
                //return next();
            } else {
                alert("You don't have access to this page!")
                router.push({ path: '/event/list' })
            }

        }

        return next()
            // Specify the current path as the customState parameter, meaning it
            // will be returned to the application after auth
            // auth.login({ target: to.path });

    })

})

router.checkLoginTime = function() {
    // check login time more than 24hr
    if(ls.getSessionValueByKey('il')){
        let LoginTime = ls.getSessionValueByKey('LoginTime');
        let CurrentTime = new Date().getTime();
        let hours = ((CurrentTime-LoginTime) / (1000 * 60 * 60)).toFixed(1);
        if(hours > 24)
        {
          ls.sessionLogOut();
          router.push('/pages/login');
        }
    }
}

export default router